<template>
  <div
    :style="{
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '12px',
    }"
  >
    <div v-if="list.length > 0" class="goods-card-list" >
      <div 
        class="goods-card-item"
        v-for="item in list"
        :key="item.id"
      >
        <el-card shadow="always" class="goods-card">
          <div v-if="item.isTop" class="goods-tag">推荐</div>
          <div class="top-info">
            <div class="left-checked">
              <el-checkbox
                :value="item.ischecked"
                @change="handleChange($event, item)"
              ></el-checkbox>
            </div>
            <div
              class="right-image text-pointer"
              @click="toProductDetail(item)"
              :style="`height: ${imgHeight}`"
            >
              <img :src="item.mainImages[0]" />
            </div>
          </div>
          <div class="body-part">
            <div class="middle-info">
              <div class="mar-10 goods-name" v-if="showList.title">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.title"
                      placement="top-start"
                  >
                      <span> {{ item.title }}</span>
                  </el-tooltip>
              </div>
              <div class="goods-info-row" v-if="showList.distributePrice || showList.freightRuleList">
                  <div class="flex space-between" v-if="showList.distributePrice">
                    <div class="distributor-price">
                        分销价:
                        <strong
                        v-if="item.levelDistributionPrice === -1"
                        class="text-orange ftsz16"
                        >
                        合作后查看
                        </strong>
                        <span v-else>
                          <span style="color: #ff0000; font-size: 12px;" v-if="item.levelDistributionPrice || item.levelDistributionPrice === 0">￥</span>
                          <strong style="color: #ff0000; font-size: 16px" v-if="item.levelDistributionPrice || item.levelDistributionPrice === 0">
                            <AmountDigitText :value="item.levelDistributionPrice" :precision="amountPrecision"/>
                          </strong>
                          <span v-else>--</span>
                          <span v-if="item.levelDistributionPrice || item.levelDistributionPrice === 0" style="color: #ff0000; font-size: 12px;">起</span>
                        </span>
                        
                        <!-- 不是合作中但是有分销价的显示合作后更优惠 -->
                        <strong
                        v-if="item.levelDistributionPrice !== -1 && isInCooperation !== 2"
                        class="text-green"
                        >
                        合作后更优惠
                        </strong>
                    </div>
                  </div>
                  <div v-if="showList.freightRuleList && (item.levelDistributionPrice !== -1 && isInCooperation === 2) && getFreightPriceTag(item)">
                      <span class="shippingFee" @click.stop="showFreightDialog(item)">{{getFreightPriceTag(item)}}<i class="el-icon-Group-26"></i></span>
                  </div>
              </div>
              <div class="goods-info-row" style="margin-top: 8px;">
                  <div class="soldQuantity30D-col" v-if="item.supplyOperateDataVo && JudgeEmptyKey(item.supplyOperateDataVo.soldQuantity30D)">
                      <span class="operational-info">月销量:  <span class="spicNum">{{ specialFieldDisplay(item.supplyOperateDataVo.soldQuantity30D) }}</span></span>
                  </div>
                  <div v-if="showList.commissionPrice || showList.commissionScale">
                      <div class="gain">
                        <div style="display:flex;align-items: center;" v-if="showList.commissionPrice || item.commissionPrice===0"><span class="zuan">赚</span><span class="num">{{item.commissionPrice || '-'}}</span></div>
                        <div style="display:flex;align-items: center;" v-if="showList.commissionScale"><span class="yong">拥</span>{{item.commissionScale || '-'}}</div>
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="showList.canPublishPlatform" class="goods-info-row" style="margin-top: 8px;">
                <div class="can-plateform"> 
                    <CanPublishPlatform
                        :canPublishPlatform="item.canPublishPlatform"
                    />
                </div>
                <el-tooltip
                    v-if="item.receiveAddressId"
                    effect="dark"
                    content="点击查看供销商售后信息"
                    placement="top-start"
                >
                    <span class="icon-tui" @click="handleViewAddress(item)">退</span>
                </el-tooltip>
            </div>

            <el-row style="height:18px;margin-top: 12px;">
                <el-col :span="22">
                    <div class="outer-code" v-if="showList.outerId">
                    款式编码：<el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.outerId"
                        placement="top-start"
                    >
                        <span>{{ item.outerId }}</span>
                    </el-tooltip>
                    </div>
                </el-col>
            </el-row>
            <el-row style="color:#8C8C8C;margin-top: 12px;height:18px;" v-if="isShowMedifyOperationalBtn">
                <el-col v-if="item.supplyOperateDataVo && JudgeEmptyKey	(item.supplyOperateDataVo.deliverRate48H)" class="operational-col" :span="12">
                    <span class="operational-info">24h支付揽收率: <span class="spicNum">{{ item.supplyOperateDataVo.deliverRate48H }}%</span></span>
                </el-col>
                <el-col v-if="item.supplyOperateDataVo && JudgeEmptyKey	(item.supplyOperateDataVo.afterSalesRate)"  class="operational-col" :span="8">
                    <span class="operational-info">售后率: {{ item.supplyOperateDataVo.afterSalesRate }} %</span>
                </el-col>
            </el-row>

            <!-- <el-row>
                <el-col v-if="item.supplyOperateDataVo && JudgeEmptyKey	(item.supplyOperateDataVo.publishCount30D)" class="operational-col" :span="10">
                    <span class="operational-info">月铺货量:<span class="spicNum">{{ specialFieldDisplay(item.supplyOperateDataVo.publishCount30D) }}</span> </span>
                </el-col>
            </el-row> -->

            <!-- 浏览数据相关 -->
            <div class="data-row">
                <!-- 浏览人数 -->
                <el-tooltip effect="dark" content="浏览人数" placement="top">
                    <div class="data-row-item">
                        <i class="el-icon-ai44 data-row-item_icon" style="font-size: 18px;color:#8C8C8C;" />
                        {{ item.viewCount || 0 }}
                    </div>
                </el-tooltip>
                <!-- 收藏人数 -->
                <el-tooltip effect="dark" content="收藏人数" placement="top">
                    <div class="data-row-item">
                        <img src="@/assets/images/icon/collect_icon.png" style="width: 16px;margin-right:4px;" alt=""/>
                        {{ item.favoriteCount || 0 }}
                    </div>
                </el-tooltip>
                <!-- 铺货店铺数 -->
                <el-tooltip effect="dark" content="铺货店铺数" placement="top">
                    <div class="data-row-item">
                        <img src="@/assets/images/icon/relay_icon.png" style="width: 14px;margin-right:4px;" alt=""/>
                        {{ item.publicCount || 0 }}
                    </div>
                </el-tooltip>
                <el-popover
                    class="data-row_help"
                    placement="top"
                    title="近30天统计数"
                    :content="`最近更新日期：${yesterday}，每日2点更新`"
                    trigger="hover">
                    <i slot="reference" class="el-icon-bangzhuzhongxin" />
                </el-popover>
            </div>

            <div v-if="!readonly" class="bottom-info">
              <el-tooltip class="item" effect="dark" placement="top" content="一键铺货" :disabled="tooltopDisabled">
                <div class="text-pointer" @click="operate('shelves', item)" @mouseenter="tooltopDisabled = false">
                  <i class="el-icon-top"></i>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" placement="top" :content="getJoinText(item)" :disabled="tooltopDisabled">
                <div class="text-pointer relative mgl12" @click="operate('join', item)" @mouseenter="tooltopDisabled = false">
                  <i class="el-icon-circle-plus-outline"></i>
                  <!-- 已加入分销商品 -->
                  <!-- <i v-if="item.isDistributor" class="el-icon-success isDistributor"></i> -->
                  <img
                    v-if="item.isDistributor"
                    src="https://img.alicdn.com/imgextra/i1/2211227103034/O1CN0151DY6V1YHcSwYAPCk_!!2211227103034.png"
                    alt=""
                    class="isDistributor"
                  >
                  <img
                    v-if="item.isDistributor && item.isHaveNewDisSku"
                    src="https://img.alicdn.com/imgextra/i3/2211227103034/O1CN01jsxPRv1YHcT14YjmF_!!2211227103034.png"
                    alt=""
                    class="isDistributor"
                  >
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" placement="top" content="更新分销商品" :disabled="tooltopDisabled">
                <div class="text-pointer relative mgl12" @click="operate('update', item)" @mouseenter="tooltopDisabled = false">
                  <i class="kmt-iconfont kmt-icon-gengxin"></i>
                </div>
              </el-tooltip>
              <!-- <el-button type="text" @click="$emit('import', item)"
                >导入商品</el-button
              > -->
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <template v-else>
      <el-col
        style="
          color: #909399;
          text-align: center;
          font-size: 12px;
        "
      >
        <img width="160px" src="https://img.alicdn.com/imgextra/i4/2211227103034/O1CN0155lRG91YHcRBChlaU_!!2211227103034.png" alt="">
        <div>暂无数据</div>
      </el-col>
    </template>
    <FreightDialog />
    <el-dialog
      :visible.sync="afterSalesVisible"
      title="售后信息"
      width="600px"
      @close="closeHandle"
    >

      <div class="addressItem">
          <span>退款地址：{{`${receiveAddress.receiveName} ${receiveAddress.phone} ${receiveAddress.province}${receiveAddress.city}${receiveAddress.district}${receiveAddress.detailAddress}`}}</span>
          <el-button 
            v-clipboard:copy="`${receiveAddress.receiveName} ${receiveAddress.phone} ${receiveAddress.province}${receiveAddress.city}${receiveAddress.district}${receiveAddress.detailAddress}`"
            v-clipboard:success="handleOnCopy"
            type="link" 
          >复制</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="closeHandle">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters as mapGettersVuex  } from "vuex";
import { mapActions as mapActionsSupplier } from "@supplier/commodity/components/List/store"
import tableMixins from "@mixins/table-mixins";
import CanPublishPlatform from "./canPublishPlatform.vue";
import FreightDialog from '@supplier/commodity/components/List/components/ListPart/components/FreightDialog/index.vue';
import { throttle } from 'lodash';
import { getShopSettingConf,getItemReceiveAddress } from '@servers/commodity'
import dayjs from 'dayjs'
import _ from 'lodash'
import { DEFAULT_AMOUNT_DIGIT } from '@/dictionary/index.js';
import { CheckFeatureWhitelistPower } from '@/utils/powerConsts.js'

export default {
  mixins: [new tableMixins(319, { refName: "search" })],
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: Boolean,
    isInCooperation: Number,
    supplierCompanyId: [String, Number],
    readonly: {
      type: Boolean,
      default: false,
    },
    amountPrecision: {
      type: Number,
      default: DEFAULT_AMOUNT_DIGIT,
    },
  },
  components: {
    CanPublishPlatform,
    FreightDialog,
  },
  data() {
    return {
      selectedArr: [],
      tooltopDisabled: false,
      imgHeight: '15vw',
      showList:{
          "distributePrice": false,
          "commissionPrice": false,
          "commissionScale": false,
          "title": false,
          "outerId": false,
          "canPublishPlatform": false,
          "freightRuleList":false,
      },
      afterSalesVisible:false,
      receiveAddress:{}, //售后地址
    };
  },
  watch: {
    list:{
      handler(newVal){
        setTimeout(() => {
          this.calcImgHeight();
        }, 1000);
      },
      deep: true
    }
  },
  computed: {
    ...mapGettersVuex(['userBtnPowerConsts']),
    rowHeight() {
      return {
        height: `${this.autoHeight}px`,
      };
    },
    yesterday() {
        return dayjs().subtract(1, 'day').format("YYYY-MM-DD")
    },
    yesterday() {
        return dayjs().subtract(1, 'day').format("YYYY-MM-DD")
    },
    isShowMedifyOperationalBtn () {
        return CheckFeatureWhitelistPower(this.userBtnPowerConsts.PROD_CENTER_BATCH_MODIFY_OPERATION)
    },
  },
  created() {
    this.getTabConfig()
  },
  mounted() {
    window.addEventListener('resize', throttle(this.calcImgHeight, 500));
  },

  methods: {
    ...mapActionsSupplier(['updateFreightModalParams']),
    async getTabConfig(){
        const companyId  = this.supplierCompanyId;
        const res = await getShopSettingConf({companyId});
        let list = res?.pcShopSetting.pcShopCard.shopFieldConf || [];
        list.forEach(item=>{
            this.showList[item.filed] = item.ifEnable;
        })
    },
    handleChange(e, item) {
      item.ischecked = e;
      if (e) {
        this.selectedArr.push({ ...item });
      } else {
        const index = this.selectedArr.findIndex(value => {
          return value.id === item.id;
        });
        if (index === -1) return;
        this.selectedArr.splice(index, 1);
      }
      this.$emit('updateSelectedGoods', this.selectedArr, e);
    },
    method_getSelectedArr() {
      return this.selectedArr;
    },
    methods_clearSelectedArr() {
      this.selectedArr = [];
    },

    toProductDetail(item) {
      this.$store.commit('setIsKeepAlive', false);
      this.$router.push({
        name: 'd_ProductDetail',
        params: { productId: item.baseItemId },
        query: { supplierId: item.companyId, readonly: this.readonly }
      });
    },

    operate(type, item) {
      this.tooltopDisabled = true;
      this.$emit(type, item);
    },
    calcImgHeight() {
      let dom = document.getElementsByClassName('top-info')[0];
      if (dom) {
        this.imgHeight = `${dom.offsetWidth}px`;
      }
    },
    getJoinText(item) {
      if (item.isDistributor && item.isHaveNewDisSku) {
        return '有新增sku待加分销'
      } else if (item.isDistributor) {
        return '已加入分销商品'
      } else {
        return '加入分销商品'
      }
    },
    /**
     * 判断是否为空值
     * @param {*} obj 
     * @returns 
     */
    JudgeEmptyKey (v) {
        return !(_.isNull(v) || _.isUndefined(v) || (_.isObjectLike(v) && _.isEmpty(v)));
    },
    /**
     * 特殊字段显示
     * @param {*} obj 
     * @returns 
     */
    specialFieldDisplay (value) {
        let text = 0;
        if (value >= 0 && value < 100) {
            text = value
        } else if (value >= 100 && value < 10000) {
            text = `${ Math.floor(value / 100) }00+`;
        } else if (value >= 10000) {
            text = `${ (Math.floor(value * 10 / 10000) / 10).toFixed(1) }万+`;
        }
        return text;
    },
    getFreightPriceTag(row){
        let freight_detail = '';
        let freight_rule = row.freightRuleList && row.freightRuleList[0]?.dmsFreightRuleList[0];
        let calculateType = freight_rule?.calculateType;
        let minCost = Infinity;
        let tagName = '';
        // 获取不同类型的运费下的运费规则
        switch(calculateType) {
            case 1:
                freight_detail = freight_rule?.weightStrategy;
                break;
            case 2:
                freight_detail = freight_rule?.volumeStrategy;
                break;
            case 3:
                freight_detail = freight_rule?.recordNumStrategy;
                break;
            case 4:
                freight_detail = freight_rule?.orderStrategy;
                break;
            default:
                freight_detail = null;
        }
        if (freight_detail) {
            try{
                freight_detail = JSON.parse(freight_detail);
            }catch(e){ freight_detail = {} }
            // 找到最低运费
            const findMinCost = (strategies, costField) => {
                return Math.min(...strategies.map(strategy => strategy[costField] ?? Infinity));
            };
            const findMinCostInSubList = (strategies, subListField, costField) => {
                return Math.min(...strategies.flatMap(strategy => 
                    (strategy[subListField] || []).map(subStrategy => subStrategy[costField] ?? Infinity)
                ));
            };
            switch(calculateType) {
                case 1:
                    minCost = findMinCostInSubList(freight_detail, 'subWeightStrategyList', 'cost');
                    tagName = minCost === Infinity ? '' : `首重${minCost}元`
                    break;
                case 2:
                    minCost = findMinCost(freight_detail, 'volMinCost');
                    tagName = minCost === Infinity ? '' : `首费${minCost}元`
                    break;
                case 3:
                    minCost = findMinCostInSubList(freight_detail, 'subNumStrategyList', 'firstCost');
                    tagName = minCost === Infinity ? '' : `首件${minCost}元`
                    break;
                case 4:
                    minCost = findMinCost(freight_detail, 'anyOrderCost');
                    tagName = minCost === Infinity ? '' : `首单${minCost}元`
                    break;
            }
        }
        return tagName
    },
    showFreightDialog(data){
        if (!data.freightRuleList || !data.freightRuleList.length) {
            return;   
        }
        const params = {
            visible: true,
            matchFreightRuleList: data.freightRuleList || [],
        }
        this.updateFreightModalParams(params)
    },
    async handleViewAddress(row){
      let res = await getItemReceiveAddress({
        baseItemId:row.baseItemId,
        companyId:row.companyId
      })
      if(res){
        this.receiveAddress = res;
        this.afterSalesVisible = true;
      }
    },
    handleOnCopy() {
      this.$message.success('复制成功');
    },
    closeHandle(){
      this.afterSalesVisible = false
    }
  },
};
</script>

<style lang="scss" scoped>
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.goods-card-list{
  display: flex;
  flex-wrap: wrap;
  min-width: 1300px;
  .goods-card-item{
    position: relative;
    width: 260px;
    padding: 0 5px;
    margin-bottom: 20px;
    box-sizing: border-box;
  }
  .body-part{
    padding: 0 10px 0px 10px;
    position: relative;
  }
  .goods-info-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 26px;
  }
  .outer-code {
    color: #909399;
    height: 16px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .data-row {
      position: relative;
      display: flex;
      height: 34px;
      align-items: center;
      justify-content: space-between;
      padding: 0 50px 0 10px;
      margin-top: 12px;
      margin-bottom: 10px;
      border-radius: 5px;
      background: #FBFBFB;
      border: 1px dashed #DFE2E8;

      &-item {
          display: flex;
          align-items: center;
          &_icon {
              color: #b1b1b1;
              margin-right: 5px;
          }
      }
      .data-row_help {
          position: absolute;
          font-size: 15px;
          top: 4px;
          right: 6px;
          color: #aaa;
      }
  }
  .shippingFee{
      font-size: 12px;
      color: #396CF3;
      padding: 0 2px;
      background: #F1F6FF;
      border-radius: 2px;
      border: 1px solid #B1C6FF;
      cursor: pointer;
  }
}

// .good-item {
//   // width: 20%;
//   min-width: 240px;
//   position: relative;
// }
.goods-tag {
  position: absolute;
  background-color: #2695FA;
  right: 5%;
  top: 3%;
  z-index: 10;
  border-radius: 4px;
  color: #fff;
  padding: 2px 8px;
}
.top-info {
  display: flex;
  align-items: flex-start;
  position: relative;
  // margin: -20px -20px 0 -20px;
  .left-checked {
    position: absolute;
    top: 12px;
    left: 12px;
  }
  .right-image {
    flex: 1;
    width: 100%;
    height: 100%;
    // height: 15vw;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}
::v-deep .el-image__inner {
  object-fit: contain;
  object-position: center;
}
::v-deep .el-card {
  // margin: 0 5px 5px 5px;
  .el-card__body {
    padding: 0;
    // padding-bottom: 0;
  }
}
.middle-info {
  font-size: 14px;
  // padding: 10px;
  padding-top: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #DFE2E8;
  .mar-10 {
    margin-bottom: 10px;
  }
  .distributor-price {
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .mar-r-10 {
    margin-right: 10px;
  }
  .sale-price {
    color: #909399;
    height: 18px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .goods-name {
    font-size: 16px;
    line-height: 18px;
    font-weight: bold;
    overflow: hidden;
    text-overflow:ellipsis;
    height: 36px;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2; // 设置两行文字溢出
    -webkit-box-orient: vertical;
  }
  .can-plateform {
    display: flex;
    align-items: center;
    height: 25px;
  }
  .operational-col{
    text-align: right;
    .operational-info{
        font-size: 12px;
        text-align: right;
        .spicNum{
            font-weight: 800;
            color: #F9A809;
        }
    }
  }
  
}
.bottom-info {
  background-color: #f2f2f2;
  margin: 0 -20px;
  padding: 6px 20px;
  display: flex;
  justify-content: flex-end;
  color: #666;
  font-size: 18px;
  .el-button {
    padding: 5px;
  }
  .isDistributor {
    position: absolute;
    font-size: 14px;
    color: rgb(31, 162, 1);
    bottom: -2px;
    right: -4px;
    width: 13px;
  }
}
.gain{
  display: flex;
  max-width: 130px;
  font-size: 12px;
  // padding: 5px 0px;
  // margin-bottom: 10px;
  .zuan,.yong{
    padding: 0 3px;
    border-radius: 4px;
    color:#fff;
  }
  .zuan{
    background: #F9A809;
    margin-right: 4px;
  }
  .num{
    margin-right: 12px;
  }
  .yong{
    background: #0AB1BC;
    margin-right: 4px;
  }
}
.icon-tui{
    padding: 0 3px;
    border-radius: 4px;
    color: #fff;
    background: #F9A809;
    cursor: pointer;
}
</style>
